import axios from 'axios';
import store from '../../store/index';

export default {
	get() {
		return axios.get(`api/status`);
	},
	getVersion() {
		return axios.get(`api/version`, {
			headers: {
				Authorization: `Bearer ${store.state.auth.token}`,
			},
		});
	},
};
